import * as localforage from 'localforage';

localforage.config({
    driver: localforage.INDEXEDDB,
    name: process.env.REACT_APP_INDEX_DB_NAME
});

export const getStorageValue = (key) => {
    return localforage.getItem(key);
};

export const setStorageValue = (key, value) => {
    return localforage.setItem(key, value);
};

export const removeStorageValue = (key) => {
    return localforage.removeItem(key);
};

export const deleteAllStorageValues = () => {
    return localforage.clear();
};

export const listStorageKeys = () => {
    return localforage.keys();
};